class GalleryFilter {
  constructor(container) {
    this.container = container;
    this.grid = this.container.querySelector('[data-gallery-grid]');
    this.filterBtns = this.container.querySelectorAll('.filter-btn');
    this.items = this.container.querySelectorAll('[data-filter-item]');
    
    this.init();
  }

  init() {
    if (!this.grid || !this.filterBtns.length) return;
    
    this.bindEvents();
    this.setInitialLayout();
  }

  bindEvents() {
    this.filterBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleFilterClick(e.target);
      });
    });
  }

  handleFilterClick(btn) {
    const filter = btn.getAttribute('data-filter');
    
    // Update button states
    this.filterBtns.forEach(filterBtn => {
      filterBtn.classList.remove('active');
    });
    btn.classList.add('active');
    
    // Filter items
    this.filterItems(filter);
  }

  filterItems(filter) {
    this.items.forEach(item => {
      const itemType = item.getAttribute('data-filter-item');
      const shouldShow = filter === 'all' || itemType === filter;
      
      if (shouldShow) {
        item.style.display = 'block';
        item.style.opacity = '1';
        item.style.transition = 'none';
      } else {
        item.style.display = 'none';
        item.style.opacity = '0';
        item.style.transition = 'none';
      }
    });
    
    // Re-layout grid immediately
    this.layoutGrid();
  }

  setInitialLayout() {
    this.layoutGrid();
  }

  layoutGrid() {
    if (!this.grid) return;
    
    // Apply masonry-like layout for mixed sizes
    const visibleItems = Array.from(this.items).filter(item => {
      return item.style.display !== 'none' && item.style.opacity !== '0';
    });
    
    // Reset any previous positioning
    visibleItems.forEach(item => {
      item.style.transform = '';
    });
  }
}

// Auto-initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  const galleryFilterSections = document.querySelectorAll('[data-section-type="gallery-filter"]');
  galleryFilterSections.forEach(section => {
    new GalleryFilter(section);
  });
});

// Re-initialize on Shopify section loads (theme editor)
document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('[data-section-type="gallery-filter"]')) {
    new GalleryFilter(e.target);
  }
}); 